export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13528.b1896031.jpg";